import React, { Fragment } from 'react'
import { Button, Form } from 'react-bootstrap'
import { FaEyeSlash } from 'react-icons/fa6'
import InputIcon from '../Main/InputIcon'
import Loader from '../Main/Loader'
import useCreateNewPassword from '../../Hooks/Auth/useCreateNewPassword'

const CreateNewPasswordPage = () => {

    const [
        password,
        confirmPassword,
        isLoading,
        handlePassword,
        handleConfirmPassword,
        handleSubmit
    ] = useCreateNewPassword();


    return (
        <Fragment>

            <div className="auth-background" style={{ height: "100vh" }}>
                <div className="overlay h-100" >
                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-5 mt-5">
                                <div className="mt-5 card bg-white border-0 p-5">
                                    <h5 className='heading'>
                                        Forgot Password
                                    </h5>

                                    <p>
                                        Create new password and confirm
                                    </p>

                                    <Form onSubmit={handleSubmit} className='row'>
                                        <InputIcon
                                            type="password"
                                            placeholder="Create New Password"
                                            icon={<FaEyeSlash />}
                                            value={password}
                                            handleChange={handlePassword}
                                        />
                                        <InputIcon
                                            type="password"
                                            placeholder="Confirm New Password"
                                            icon={<FaEyeSlash />}
                                            value={confirmPassword}
                                            handleChange={handleConfirmPassword}
                                        />
                                        <div className='p-0'>
                                            <Button type='submit' className='btn btn-danger w-100 py-3'>
                                                {
                                                    isLoading ? <Loader /> : "Submit"
                                                }
                                            </Button>
                                        </div>
                                    </Form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default CreateNewPasswordPage